const actions = {
    GET_NETWORK_BY_DEALER_PORTIN_MAPPING: 'GET_NETWORK_BY_DEALER_PORTIN_MAPPING',
    GET_NETWORK_BY_DEALER_PORTIN_MAPPING_SUCCESS: 'GET_NETWORK_BY_DEALER_PORTIN_MAPPING_SUCCESS',
    GET_NETWORK_BY_DEALER_PORTIN_MAPPING_FAILED: 'GET_NETWORK_BY_DEALER_PORTIN_MAPPING_FAILED',

    CREATE_PORTIN_ACTIVATION: 'CREATE_PORTIN_ACTIVATION',
    CREATE_PORTIN_ACTIVATION_SUCCESS: 'CREATE_PORTIN_ACTIVATION_SUCCESS',
    CREATE_PORTIN_ACTIVATION_FAILED: 'CREATE_PORTIN_ACTIVATION_FAILED',

    GET_BULK_PORTIN_ACTIVATION: 'GET_BULK_PORTIN_ACTIVATION',
    GET_BULK_PORTIN_ACTIVATION_SUCCESS: 'GET_BULK_PORTIN_ACTIVATION_SUCCESS',
    GET_BULK_PORTIN_ACTIVATION_FAILED: 'GET_BULK_PORTIN_ACTIVATION_FAILED',

    RESET_MESSAGES: 'RESET_MESSAGES',
    RESET_DATA: 'RESET_DATA',

    CHECK_SERIAL_NUMBER_BY_BATCH: 'CHECK_SERIAL_NUMBER_BY_BATCH',
    CHECK_SERIAL_NUMBER_BY_BATCH_SUCCESS: 'CHECK_SERIAL_NUMBER_BY_BATCH_SUCCESS',
    CHECK_SERIAL_NUMBER_BY_BATCH_FAILED: 'CHECK_SERIAL_NUMBER_BY_BATCH_FAILED',

    UPDATE_MANUAL_PORTIN_ACTIVATION: 'UPDATE_MANUAL_PORTIN_ACTIVATION',
    UPDATE_MANUAL_PORTIN_ACTIVATION_SUCCESS: 'UPDATE_MANUAL_PORTIN_ACTIVATION_SUCCESS',
    UPDATE_MANUAL_PORTIN_ACTIVATION_FAILED: 'UPDATE_MANUAL_PORTIN_ACTIVATION_FAILED',

    RESET_SUCCESS_MESSAGES: 'RESET_SUCCESS_MESSAGES',

    UPDATE_PORTIN_STATUS: "UPDATE_PORTIN_STATUS",
    UPDATE_PORTIN_STATUS_SUCCESS: "UPDATE_PORTIN_STATUS_SUCCESS",
    UPDATE_PORTIN_STATUS_FAILED: "UPDATE_PORTIN_STATUS_FAILED",

    UPDATE_PORTIN_ACTIVATION_BULK_STATUS: "UPDATE_PORTIN_ACTIVATION_BULK_STATUS",
    UPDATE_PORTIN_ACTIVATION_BULK_STATUS_SUCCESS: "UPDATE_PORTIN_ACTIVATION_BULK_STATUS_SUCCESS",
    UPDATE_PORTIN_ACTIVATION_BULK_STATUS_FAILED: "UPDATE_PORTIN_ACTIVATION_BULK_STATUS_FAILED",

    GET_BULK_PORTIN_ACTIVATION_LIST: 'GET_BULK_PORTIN_ACTIVATION_LIST',
    GET_BULK_PORTIN_ACTIVATION_LIST_SUCCESS: 'GET_BULK_PORTIN_ACTIVATION_LIST_SUCCESS',
    GET_BULK_PORTIN_ACTIVATION_LIST_FAILED: 'GET_BULK_PORTIN_ACTIVATION_LIST_FAILED',

    GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID: 'GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID',
    GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID_SUCCESS: 'GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID_SUCCESS',
    GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID_FAILED: 'GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID_FAILED',
    
    OPEN_ADD_PORTIN_MODAL: 'OPEN_ADD_PORTIN_MODAL',
    CLOSE_ADD_PORTIN_MODAL: 'CLOSE_ADD_PORTIN_MODAL',

    GET_PORTIN_ACTIVATIONS: 'GET_PORTIN_ACTIVATIONS',
    GET_PORTIN_ACTIVATIONS_SUCCESS: 'GET_PORTIN_ACTIVATIONS_SUCCESS',
    GET_PORTIN_ACTIVATIONS_FAILED: 'GET_PORTIN_ACTIVATIONS_FAILED',

    getPortinActivations: (data) => ({
        type: actions.GET_PORTIN_ACTIVATIONS,
        payload: { data }
    }),
    getPortinActivationsSuccess: (data) => ({
        type: actions.GET_PORTIN_ACTIVATIONS_SUCCESS,
        payload: { data }
    }),
    getPortinActivationsFailed: (error) => ({
        type: actions.GET_PORTIN_ACTIVATIONS_FAILED,
        payload: { error }
    }),

    openAddPortinModal: () => ({
        type: actions.OPEN_ADD_PORTIN_MODAL,
    }),
    closeAddPortinModal: () => ({
        type: actions.CLOSE_ADD_PORTIN_MODAL,
    }),

    getBulkPortinActivationListByBatchID: (data) => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID,
        payload: { data }
    }),
    getBulkPortinActivationListByBatchIDSuccess: (result) => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID_SUCCESS,
        result
    }),
    getBulkPortinActivationListByBatchIDFailed: (error) => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID_FAILED,
        error
    }),

    getBulkPortinActivationList: () => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION_LIST,
    }),
    getBulkPortinActivationListSuccess: (result) => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION_LIST_SUCCESS,
        result
    }),
    getBulkPortinActivationListFailed: (error) => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION_LIST_FAILED,
        error
    }),

    updatePortinActivationBulkStatus: (searchData) => ({
        type: actions.UPDATE_PORTIN_ACTIVATION_BULK_STATUS,
        payload: { searchData }
    }),
    updatePortinActivationBulkStatusSuccess: (message) => ({
        type: actions.UPDATE_PORTIN_ACTIVATION_BULK_STATUS_SUCCESS,
        message
    }),
    updatePortinActivationBulkStatusFailed: (error) => ({
        type: actions.UPDATE_PORTIN_ACTIVATION_BULK_STATUS_FAILED,
        error
    }),

    updatePortinStatus: (updateData, data) => ({
        type: actions.UPDATE_PORTIN_STATUS,
        payload: { updateData, data }
    }),
    updatePortinStatusSuccess: (message) => ({
        type: actions.UPDATE_PORTIN_STATUS_SUCCESS,
        message
    }),
    updatePortinStatusFailed: (error) => ({
        type: actions.UPDATE_PORTIN_STATUS_FAILED,
        error
    }),

    resetData: () => ({
        type: actions.RESET_DATA,
    }),

    resetMessage: () => ({
        type: actions.RESET_MESSAGES,
    }),

    getNetworkByDealerPortinMapping: () => ({
        type: actions.GET_NETWORK_BY_DEALER_PORTIN_MAPPING,
    }),
    getNetworkByDealerPortinMappingSuccess: (result) => ({
        type: actions.GET_NETWORK_BY_DEALER_PORTIN_MAPPING_SUCCESS,
        result
    }),
    getNetworkByDealerPortinMappingFailed: (error) => ({
        type: actions.GET_NETWORK_BY_DEALER_PORTIN_MAPPING_FAILED,
        error
    }),

    createPortinActivation: (data) => ({
        type: actions.CREATE_PORTIN_ACTIVATION,
        data
    }),
    createPortinActivationSuccess: (result, message) => ({
        type: actions.CREATE_PORTIN_ACTIVATION_SUCCESS,
        result, message
    }),
    createPortinActivationFailed: (error) => ({
        type: actions.CREATE_PORTIN_ACTIVATION_FAILED,
        error
    }),

    getBulkPortinActivation: (data) => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION,
        payload: { data }
    }),
    getBulkPortinActivationSuccess: (result) => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION_SUCCESS,
        result
    }),
    getBulkPortinActivationFailed: (error) => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION_FAILED,
        error
    }),

    checkSerialNumberByBatch: (data) => ({
        type: actions.CHECK_SERIAL_NUMBER_BY_BATCH,
        payload: { data }
    }),
    checkSerialNumberByBatchSuccess: (result) => ({
        type: actions.CHECK_SERIAL_NUMBER_BY_BATCH_SUCCESS,
        result
    }),
    checkSerialNumberByBatchFailed: (error) => ({
        type: actions.CHECK_SERIAL_NUMBER_BY_BATCH_FAILED,
        error
    }),

    updateManualPortinActivation: (data) => ({
        type: actions.UPDATE_MANUAL_PORTIN_ACTIVATION,
        data
    }),
    updateManualPortinActivationSuccess: (message) => ({
        type: actions.UPDATE_MANUAL_PORTIN_ACTIVATION_SUCCESS,
        message
    }),
    updateManualPortinActivationFailed: (error) => ({
        type: actions.UPDATE_MANUAL_PORTIN_ACTIVATION_FAILED,
        error
    }),
    resetSucessMessage: () => ({
        type: actions.RESET_SUCCESS_MESSAGES,
    }),


};
export default actions;
